/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedTopTileController_viewer = {
    readonly showCreatorDesignTiles: boolean | null;
    readonly regions?: ReadonlyArray<{
        readonly regionName: string | null;
        readonly urlLabel: string | null;
    } | null> | null;
    readonly " $refType": "SbSharedTopTileController_viewer";
};
export type SbSharedTopTileController_viewer$data = SbSharedTopTileController_viewer;
export type SbSharedTopTileController_viewer$key = {
    readonly " $data"?: SbSharedTopTileController_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedTopTileController_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedTopTileController_viewer",
  "selections": [
    {
      "alias": "showCreatorDesignTiles",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "sbCreatorDesignTiles"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"sbCreatorDesignTiles\")"
    },
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "address",
              "value": {
                "country": "us"
              }
            },
            {
              "kind": "Literal",
              "name": "regionBoundaryTypes",
              "value": [
                "METROPOLITAN",
                "DISTRICT",
                "DOMESTIC"
              ]
            },
            {
              "kind": "Literal",
              "name": "regionType",
              "value": "ITEM_LOCATION"
            }
          ],
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "regions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7bb57f9ed4564d04cccab1bc3f3ef6ab';
export default node;
